<ng-container *ngIf="lead?.metadata">
  <ng-container
    *ngIf="
      lead.insuranceType === InsuranceType.HEALTH ||
      lead.insuranceType === InsuranceType.COMPLEMENTARY_HEALTH
    "
  >
    <app-health-metadata-v2
      [baseMetadata]="lead.metadata"
      [originalLead]="originalLead"
    />
  </ng-container>

  <ng-container *ngIf="lead.insuranceType === InsuranceType.TRAVEL">
    <app-travel-metadata-v2
      [baseMetadata]="lead.metadata"
      [originalLead]="originalLead"
    />
  </ng-container>

  <ng-container *ngIf="lead.insuranceType === InsuranceType.ANIMAL">
    <app-animal-metadata-v2
      [baseMetadata]="lead.metadata"
      [originalLead]="originalLead"
    />
  </ng-container>

  <ng-container
    *ngIf="
      lead.insuranceType === InsuranceType.BUILDING ||
      lead.insuranceType === InsuranceType.BUSINESS_BUILDING
    "
  >
    <app-building-metadata-v2
      [baseMetadata]="lead.metadata"
      [originalLead]="originalLead"
    />
  </ng-container>

  <ng-container *ngIf="lead.insuranceType === InsuranceType.CANCELLATION">
    <app-cancellation-metadata-v2
      [baseMetadata]="lead.metadata"
      [originalLead]="originalLead"
    />
  </ng-container>

  <ng-container *ngIf="lead.insuranceType === InsuranceType.CENTRALISATION">
    <app-centralisation-metadata-v2
      [baseMetadata]="lead.metadata"
      [originalLead]="originalLead"
      [leadId]="lead.leadId"
      (done)="done.emit()"
    />
  </ng-container>

  <ng-container *ngIf="lead.insuranceType === InsuranceType.CONSTRUCTION">
    <app-construction-metadata-v2
      [baseMetadata]="lead.metadata"
      [originalLead]="originalLead"
    />
  </ng-container>

  <ng-container *ngIf="lead.insuranceType === InsuranceType.RC_HOUSEHOLD">
    <app-household-metadata-v2
      [baseMetadata]="lead.metadata"
      [originalLead]="originalLead"
    />
  </ng-container>

  <ng-container *ngIf="lead.insuranceType === InsuranceType.LEGAL_PROTECTION">
    <app-legal-protection-metadata-v2
      [baseMetadata]="lead.metadata"
      [originalLead]="originalLead"
    />
  </ng-container>

  <ng-container *ngIf="lead.insuranceType === InsuranceType.THIRD_PILLAR">
    <app-third-pillar-metadata-v2
      [baseMetadata]="lead.metadata"
      [originalLead]="originalLead"
    />
  </ng-container>

  <ng-container *ngIf="lead.insuranceType === InsuranceType.VALUABLE_OBJECTS">
    <app-valuable-objects-metadata-v2
      [baseMetadata]="lead.metadata"
      [originalLead]="originalLead"
    />
  </ng-container>

  <ng-container *ngIf="lead.insuranceType === InsuranceType.MOTOR_VEHICLE">
    <app-vehicle-metadata-v2
      [baseMetadata]="lead.metadata"
      [originalLead]="originalLead"
    />
  </ng-container>

  <ng-container
    *ngIf="lead.insuranceType === InsuranceType.BUSINESS_RC_COMPANY"
  >
    <app-rc-company-metadata-v2
      [baseMetadata]="lead.metadata"
      [originalLead]="originalLead"
    />
  </ng-container>

  <ng-container
    *ngIf="lead.insuranceType === InsuranceType.BUSINESS_COMPANY_THINGS"
  >
    <app-business-things-metadata-v2
      [baseMetadata]="lead.metadata"
      [originalLead]="originalLead"
    />
  </ng-container>

  <ng-container
    *ngIf="
      lead.insuranceType === InsuranceType.BUSINESS_ACCIDENT ||
      lead.insuranceType === InsuranceType.BUSINESS_ACCIDENT_COMPLEMENTARY ||
      lead.insuranceType === InsuranceType.ACCIDENT
    "
  >
    <app-business-accident-metadata-v2
      [baseMetadata]="lead.metadata"
      [originalLead]="originalLead"
      [userId]="lead.userId"
    />
  </ng-container>

  <ng-container
    *ngIf="
      lead.insuranceType === InsuranceType.BUSINESS_HEALTH ||
      lead.insuranceType === InsuranceType.HEALTH_ALLOWANCE
    "
  >
    <app-business-health-metadata-v2
      [baseMetadata]="lead.metadata"
      [originalLead]="originalLead"
      [userId]="lead.userId"
    />
  </ng-container>

  <ng-container
    *ngIf="lead.insuranceType === InsuranceType.BUSINESS_RETIREMENT"
  >
    <app-business-retirement-metadata-v2
      [baseMetadata]="lead.metadata"
      [originalLead]="originalLead"
      [userId]="lead.userId"
    />
  </ng-container>

  <ng-container
    *ngIf="lead.insuranceType === InsuranceType.BUSINESS_MOTOR_VEHICLE"
  >
    <app-business-vehicle-metadata-v2
      [baseMetadata]="lead.metadata"
      [originalLead]="originalLead"
    />
  </ng-container>

  <ng-container *ngIf="lead.insuranceType === InsuranceType.POLICY_UPDATE">
    <app-policy-update-metadata-v2
      [baseMetadata]="lead.metadata"
      [originalLead]="originalLead"
    />
  </ng-container>

  <ng-container
    *ngIf="lead.insuranceType === InsuranceType.COLLABORATOR_DECLARATION"
  >
    <app-collaborator-metadata-v2
      [baseMetadata]="lead.metadata"
      [originalLead]="originalLead"
    />
  </ng-container>

  <ng-container
    *ngIf="lead.insuranceType === InsuranceType.BUSINESS_CYBERSECURITY"
  >
    <app-business-cyber-metadata-v2
      [baseMetadata]="lead.metadata"
      [originalLead]="originalLead"
    />
  </ng-container>

  <ng-container
    *ngIf="lead.insuranceType === InsuranceType.BUSINESS_LEGAL_PROTECTION"
  >
    <app-business-legal-protection-metadata-v2
      [baseMetadata]="lead.metadata"
      [originalLead]="originalLead"
    />
  </ng-container>

  <ng-container *ngIf="lead.insuranceType === InsuranceType.BUSINESS_FLEET">
    <app-business-fleet-metadata-v2
      [baseMetadata]="lead.metadata"
      [originalLead]="originalLead"
    />
  </ng-container>

  <ng-container *ngIf="lead.insuranceType === InsuranceType.BUSINESS_TRANSPORT">
    <app-business-transport-metadata-v2
      [baseMetadata]="lead.metadata"
      [originalLead]="originalLead"
    />
  </ng-container>

  <ng-container
    *ngIf="lead.insuranceType === InsuranceType.BUSINESS_TECHNICAL_INSTALLATION"
  >
    <app-business-technical-installation-metadata-v2
      [baseMetadata]="lead.metadata"
      [originalLead]="originalLead"
    />
  </ng-container>

  <ng-container
    *ngIf="
      lead.insuranceType === InsuranceType.BUSINESS_RENTAL ||
      lead.insuranceType === InsuranceType.BUSINESS_CONSTRUCTION_WARRANTY ||
      lead.insuranceType === InsuranceType.BUSINESS_CONSTRUCTION ||
      lead.insuranceType === InsuranceType.BUSINESS_RC_PROFESSIONAL
    "
  >
    <app-business-basic-metadata-v2
      [baseMetadata]="lead.metadata"
      [originalLead]="originalLead"
    />
  </ng-container>

  <app-card
    class="flex-basis-100 mb-12"
    *ngIf="lead?.metadata?.chosenBaseOffer"
  >
    <div cardTitle i18n>Assurance de base choisie</div>
    <div cardRows class="card__rows w-100">
      <div class="card__rows">
        <div
          class="card__row"
          *ngIf="lead.metadata?.chosenBaseOffer?.insuranceName"
        >
          <span class="card__label" i18n>Nom</span>
          <div class="d-flex gap-2 flex-column card__value">
            <span
              [ngClass]="{
                'new-lead-value':
                  originalLead?.metadata?.chosenBaseOffer?.insuranceName !==
                  lead.metadata?.chosenBaseOffer?.insuranceName,
              }"
              >{{ lead.metadata?.chosenBaseOffer?.insuranceName }}</span
            >
            <span
              class="old-lead-value"
              *ngIf="
                originalLead?.metadata?.chosenBaseOffer?.insuranceName &&
                originalLead?.metadata?.chosenBaseOffer?.insuranceName !==
                  lead.metadata?.chosenBaseOffer?.insuranceName
              "
              >{{
                originalLead?.metadata?.chosenBaseOffer?.insuranceName
              }}</span
            >
          </div>
        </div>
        <div
          class="card__row"
          *ngIf="
            lead?.metadata?.chosenBaseOffer?.productNames &&
            lead?.metadata?.chosenBaseOffer?.productNames?.length! > 0
          "
        >
          <span class="card__label" i18n>Produits</span>
          <div class="d-flex gap-2 flex-column card__value">
            <span
              [ngClass]="{
                'new-lead-value':
                  originalLead?.metadata?.chosenBaseOffer?.productNames !==
                  lead.metadata?.chosenBaseOffer?.productNames,
              }"
              >{{ lead.metadata?.chosenBaseOffer?.productNames }}</span
            >
            <span
              class="old-lead-value"
              *ngIf="
                originalLead?.metadata?.chosenBaseOffer?.productNames &&
                originalLead?.metadata?.chosenBaseOffer?.productNames !==
                  lead.metadata?.chosenBaseOffer?.productNames
              "
              >{{ originalLead?.metadata?.chosenBaseOffer?.productNames }}</span
            >
          </div>
        </div>
      </div>
      <div class="card__rows">
        <div class="card__row" *ngIf="lead.metadata?.chosenBaseOffer?.price">
          <span class="card__label" i18n>Prix</span>
          <div class="d-flex gap-2 flex-column card__value">
            <span
              [ngClass]="{
                'new-lead-value':
                  originalLead?.metadata?.chosenBaseOffer?.price !==
                  lead.metadata?.chosenBaseOffer?.price,
              }"
              >{{ lead.metadata?.chosenBaseOffer?.price }}</span
            >
            <span
              class="old-lead-value"
              *ngIf="
                originalLead?.metadata?.chosenBaseOffer?.price !== undefined &&
                originalLead?.metadata?.chosenBaseOffer?.price !==
                  lead.metadata?.chosenBaseOffer?.price
              "
              >{{ originalLead?.metadata?.chosenBaseOffer?.price }}</span
            >
          </div>
        </div>
      </div>
    </div>
  </app-card>
  <app-card
    class="flex-basis-100 mb-12"
    *ngIf="lead.metadata?.chosenComplementaryOffer"
  >
    <div cardTitle i18n>Assurance complémentaire choisie</div>
    <div cardRows class="card__rows w-100">
      <div class="card__rows">
        <div
          class="card__row"
          *ngIf="lead.metadata?.chosenComplementaryOffer?.insuranceName"
        >
          <span class="card__label" i18n>Nom</span>
          <div class="d-flex gap-2 flex-column card__value">
            <span
              [ngClass]="{
                'new-lead-value':
                  originalLead?.metadata?.chosenComplementaryOffer
                    ?.insuranceName !==
                  lead.metadata?.chosenComplementaryOffer?.insuranceName,
              }"
              >{{
                lead.metadata?.chosenComplementaryOffer?.insuranceName
              }}</span
            >
            <span
              class="old-lead-value"
              *ngIf="
                originalLead?.metadata?.chosenComplementaryOffer
                  ?.insuranceName &&
                originalLead?.metadata?.chosenComplementaryOffer
                  ?.insuranceName !==
                  lead.metadata?.chosenComplementaryOffer?.insuranceName
              "
              >{{
                originalLead?.metadata?.chosenComplementaryOffer?.insuranceName
              }}</span
            >
          </div>
        </div>
        <div
          class="card__row"
          *ngIf="
            lead?.metadata?.chosenComplementaryOffer?.productNames &&
            lead?.metadata?.chosenComplementaryOffer?.productNames?.length! > 0
          "
        >
          <span class="card__label" i18n>Produits</span>
          <div class="d-flex gap-2 flex-column card__value">
            <span
              [ngClass]="{
                'new-lead-value':
                  originalLead?.metadata?.chosenComplementaryOffer
                    ?.productNames !==
                  lead.metadata?.chosenComplementaryOffer?.productNames,
              }"
              >{{ lead.metadata?.chosenComplementaryOffer?.productNames }}</span
            >
            <span
              class="old-lead-value"
              *ngIf="
                originalLead?.metadata?.chosenComplementaryOffer
                  ?.productNames &&
                originalLead?.metadata?.chosenComplementaryOffer
                  ?.productNames !==
                  lead.metadata?.chosenComplementaryOffer?.productNames
              "
              >{{
                originalLead?.metadata?.chosenComplementaryOffer?.productNames
              }}</span
            >
          </div>
        </div>
      </div>
      <div class="card__rows">
        <div
          class="card__row"
          *ngIf="lead.metadata?.chosenComplementaryOffer?.price"
        >
          <span class="card__label" i18n>Prix</span>
          <div class="d-flex gap-2 flex-column card__value">
            <span
              [ngClass]="{
                'new-lead-value':
                  originalLead?.metadata?.chosenComplementaryOffer?.price !==
                  lead.metadata?.chosenComplementaryOffer?.price,
              }"
              >{{ lead.metadata?.chosenComplementaryOffer?.price }}</span
            >
            <span
              class="old-lead-value"
              *ngIf="
                originalLead?.metadata?.chosenComplementaryOffer?.price !==
                  undefined &&
                originalLead?.metadata?.chosenComplementaryOffer?.price !==
                  lead.metadata?.chosenComplementaryOffer?.price
              "
              >{{
                originalLead?.metadata?.chosenComplementaryOffer?.price
              }}</span
            >
          </div>
        </div>
      </div>
    </div>
  </app-card>
  <app-card class="flex-basis-100 mb-12" *ngIf="lead.metadata?.comments">
    <div cardTitle i18n>Remarques</div>
    <div cardRows class="card__rows w-100">
      <div class="card__rows w-100">
        <div class="card__row">
          <div class="d-flex gap-2 flex-column strong-text card__value">
            <span
              [ngClass]="{
                'new-lead-value':
                  originalLead?.metadata?.comments !== lead.metadata?.comments,
              }"
            >
              {{ lead.metadata?.comments }}
            </span>
            <span
              class="old-lead-value"
              *ngIf="
                originalLead?.metadata?.comments &&
                originalLead?.metadata?.comments !== lead.metadata?.comments
              "
            >
              {{ originalLead?.metadata?.comments }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </app-card>
</ng-container>
